import { STATIC_PAGES_ACTION } from './actionTypes'

export const StaticPagesStateSelectors = {
	pages: state => state.staticPages[STATIC_PAGES_ACTION.PAGES_LIST],
	articles: state => state.staticPages[STATIC_PAGES_ACTION.ARTICLES],
	banners: state => state.staticPages[STATIC_PAGES_ACTION.BANNERS],
}
